query MfaOwnerOptions($limit: Int = 1000) {
	mfa_session_runs(limit: $limit) {
		user_name_group_uniq_array
	}
}
